module.exports = __webpack_public_path__ + "img/10.9fc8d975.png";